import React, { useEffect, useState } from 'react'
import { useTrans } from '../../../../services/i18n'
import { Paper, SpacingContainer } from '../../../../components/common/Containers'
import { Grid, IconButton } from '@material-ui/core'
import Typography from '../../../../components/common/Typography'
import { Divider } from '../../../../components/common/Divider'
import { Button } from '../../../../components/common/Buttons'
import { TextField } from '../../../../components/common/Inputs'
import Loader from '../../../../components/common/Loader'
import SetupAgencyModal from './setupAgencyModal'
import EditIcon from '@mui/icons-material/Edit'
import connect from '../../connect'

function FederalAgencyResources({
  agencyLinks = [],
  getAgencyLinksList,
  updateAgencyLink
}) {
  const { trans } = useTrans()
  const [loading, setLoading] = useState(false)
  const [editId, setEditId] = useState(null)
  const [formGovLink, setFormGovLink] = useState('')
  const [formSmbLink, setFormSmbLink] = useState('')
  const [isAddOpen, setAddOpen] = useState(false)

  // slightly smaller font for table items (not headers)
  const ITEM_FONT_SIZE = '0.85rem'

  useEffect(() => {
    setLoading(true)
    getAgencyLinksList().finally(() => setLoading(false))
  }, [getAgencyLinksList])

  useEffect(() => {
    if (editId) {
      const agency = agencyLinks.find(a => a.id === editId)
      setFormGovLink(agency?.govLink || '')
      setFormSmbLink(agency?.smallBusinessLink || '')
    } else {
      setFormGovLink('')
      setFormSmbLink('')
    }
  }, [editId, agencyLinks])

  const handleSaveEdit = async () => {
    setLoading(true)
    await updateAgencyLink({
      agencyId: editId,
      govLink: formGovLink || null,
      smallBusinessLink: formSmbLink || null
    })
    await getAgencyLinksList()
    setEditId(null)
    setLoading(false)
  }

  return (
    <SpacingContainer py={2}>
      <SetupAgencyModal
        open={isAddOpen}
        onClose={() => setAddOpen(false)}
        updateAgencyLink={updateAgencyLink}
        afterSave={() => {
          setAddOpen(false)
          getAgencyLinksList()
        }}
      />

      <Paper component={SpacingContainer} py={3} px="5sm3">
        <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
          <Grid item xs zeroMinWidth>
            <Typography variant="h4" weight="500" fontFamily="lexend">
              {trans('federal-agency-links')}
            </Typography>
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" onClick={() => setAddOpen(true)}>
              {trans('add-resource')}
            </Button>
          </Grid>
        </Grid>

        <Divider light style={{ margin: '20px 0' }} />

        {loading && <Loader open={loading} />}

        {!loading && (
          <>
            {/* Column Headers */}
            <Grid
              container
              alignItems="center"
              spacing={2}
              style={{ padding: '8px 0', fontWeight: 600 }}
            >
              <Grid item xs={3}>
                <Typography variant="body2" weight="600">
                  {trans('agency-name')}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" weight="600">
                  {trans('type')}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="body2" weight="600">
                  {trans('agency-link')}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" weight="600">
                  {trans('small-business-link')}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" weight="600" align="right">
                  {trans('actions')}
                </Typography>
              </Grid>
            </Grid>

            <Divider light />

            {/* Agency Rows */}
            {agencyLinks.map(a => (
              <Grid
                container
                key={a.id}
                alignItems="center"
                spacing={2}
                style={{ padding: '8px 0' }}
              >
                {/* Agency Name */}
                <Grid item xs={3}>
                  <Typography noWrap style={{ fontSize: ITEM_FONT_SIZE }}>
                    {a.name}
                  </Typography>
                </Grid>

                {/* Type */}
                <Grid item xs={2}>
                  <Typography noWrap style={{ fontSize: ITEM_FONT_SIZE }}>
                    {a.type}
                  </Typography>
                </Grid>

                {/* Gov Link */}
                <Grid item xs={3}>
                  {editId === a.id ? (
                    <TextField
                      name="govLink"
                      value={formGovLink}
                      onChange={e => setFormGovLink(e.target.value)}
                      fullWidth
                      placeholder={trans('gov-link')}
                    />
                  ) : (
                    <Typography noWrap style={{ fontSize: ITEM_FONT_SIZE }}>
                      {a.govLink}
                    </Typography>
                  )}
                </Grid>

                {/* Small Business Link */}
                <Grid item xs={2}>
                  {editId === a.id ? (
                    <TextField
                      name="smallBusinessLink"
                      value={formSmbLink}
                      onChange={e => setFormSmbLink(e.target.value)}
                      fullWidth
                      placeholder={trans('small-business-link')}
                    />
                  ) : (
                    <Typography noWrap style={{ fontSize: ITEM_FONT_SIZE }}>
                      {a.smallBusinessLink}
                    </Typography>
                  )}
                </Grid>

                {/* Actions */}
                <Grid item xs={2} container justifyContent="flex-end" alignItems="center">
                  {editId === a.id ? (
                    <>
                      <Button variant="contained" pending={loading} onClick={handleSaveEdit}>
                        {trans('save')}
                      </Button>
                      <Button onClick={() => setEditId(null)}>{trans('cancel')}</Button>
                    </>
                  ) : (
                    <IconButton onClick={() => setEditId(a.id)}>
                      <EditIcon />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}
          </>
        )}
      </Paper>
    </SpacingContainer>
  )
}

export default connect(FederalAgencyResources)




// import React, { useEffect, useState } from 'react'
// import { useTrans } from '../../../../services/i18n'
// import { Paper, SpacingContainer } from '../../../../components/common/Containers'
// import { Grid, IconButton } from '@material-ui/core'
// import Typography from '../../../../components/common/Typography'
// import { Divider } from '../../../../components/common/Divider'
// import { Button } from '../../../../components/common/Buttons'
// import { TextField } from '../../../../components/common/Inputs'
// import Loader from '../../../../components/common/Loader'
// import SetupAgencyModal from './setupAgencyModal'
// import EditIcon from '@mui/icons-material/Edit'
// import connect from '../../connect'

// function FederalAgencyResources({
//   agencyLinks = [],
//   getAgencyLinksList,
//   updateAgencyLink
// }) {
//   const { trans } = useTrans()
//   const [loading, setLoading] = useState(false)
//   const [editId, setEditId] = useState(null)
//   const [formGovLink, setFormGovLink] = useState('')
//   const [formSmbLink, setFormSmbLink] = useState('')
//   const [isAddOpen, setAddOpen] = useState(false)

//   // load on mount
//   useEffect(() => {
//     setLoading(true)
//     getAgencyLinksList().finally(() => setLoading(false))
//   }, [getAgencyLinksList])

//   // when we enter “edit” mode, seed the links
//   useEffect(() => {
//     if (editId) {
//       const agency = agencyLinks.find(a => a.id === editId)
//       setFormGovLink(agency?.govLink || '')
//       setFormSmbLink(agency?.smallBusinessLink || '')
//     } else {
//       setFormGovLink('')
//       setFormSmbLink('')
//     }
//   }, [editId, agencyLinks])

//   const handleSaveEdit = async () => {
//     setLoading(true)
//     await updateAgencyLink({
//       agencyId: editId,
//       govLink: formGovLink || null,
//       smallBusinessLink: formSmbLink || null
//     })
//     await getAgencyLinksList()
//     setEditId(null)
//     setLoading(false)
//   }

//   return (
//     <SpacingContainer py={2}>
//       <SetupAgencyModal
//         open={isAddOpen}
//         onClose={() => setAddOpen(false)}
//         updateAgencyLink={updateAgencyLink}
//         afterSave={() => {
//           setAddOpen(false)
//           getAgencyLinksList()
//         }}
//       />

//       <Paper component={SpacingContainer} py={3} px="5sm3">
//         <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
//           <Grid item xs zeroMinWidth>
//             <Typography variant="h4" weight="500" fontFamily="lexend">
//               {trans('federal-agency-links')}
//             </Typography>
//           </Grid>
//           <Grid item>
//             <Button variant="contained" color="primary" onClick={() => setAddOpen(true)}>
//               {trans('add-resource')}
//             </Button>
//           </Grid>
//         </Grid>

//        <Divider light style={{ margin: '20px 0' }} />

// {loading && <Loader open={loading} />}

// {!loading && (
//   <>
//     {/* Column Headers */}
//     <Grid
//       container
//       alignItems="center"
//       spacing={2}
//       style={{ padding: '8px 0', fontWeight: 600 }}
//     >
//       <Grid item xs={3}>
//         <Typography variant="body2" weight="600">
//           {trans('agency-name')}
//         </Typography>
//       </Grid>
//       <Grid item xs={3}>
//         <Typography variant="body2" weight="600">
//           {trans('agency-link')}
//         </Typography>
//       </Grid>
//       <Grid item xs={3}>
//         <Typography variant="body2" weight="600">
//           {trans('small-business-link')}
//         </Typography>
//       </Grid>
//       <Grid item xs={3}>
//         <Typography variant="body2" weight="600" align="right">
//           {trans('actions')}
//         </Typography>
//       </Grid>
//     </Grid>

//     <Divider light />

//     {/* Agency Rows */}
//     {agencyLinks.map(a => (
//       <Grid
//         container
//         key={a.id}
//         alignItems="center"
//         spacing={2}
//         style={{ padding: '8px 0' }}
//       >
//         {/* Agency Name */}
//         <Grid item xs={3}>
//           <Typography noWrap>{a.name}</Typography>
//         </Grid>

//         {/* Gov Link */}
//         <Grid item xs={3}>
//           {editId === a.id ? (
//             <TextField
//               name="govLink"
//               value={formGovLink}
//               onChange={e => setFormGovLink(e.target.value)}
//               fullWidth
//               placeholder={trans('gov-link')}
//             />
//           ) : (
//             <Typography noWrap>{a.govLink}</Typography>
//           )}
//         </Grid>

//         {/* Small Business Link */}
//         <Grid item xs={3}>
//           {editId === a.id ? (
//             <TextField
//               name="smallBusinessLink"
//               value={formSmbLink}
//               onChange={e => setFormSmbLink(e.target.value)}
//               fullWidth
//               placeholder={trans('small-business-link')}
//             />
//           ) : (
//             <Typography noWrap>{a.smallBusinessLink}</Typography>
//           )}
//         </Grid>

//         {/* Actions */}
//         <Grid item xs={3} container justifyContent="flex-end" alignItems="center">
//           {editId === a.id ? (
//             <>
//               <Button variant="contained" pending={loading} onClick={handleSaveEdit}>
//                 {trans('save')}
//               </Button>
//               <Button onClick={() => setEditId(null)}>{trans('cancel')}</Button>
//             </>
//           ) : (
//             <IconButton onClick={() => setEditId(a.id)}>
//               <EditIcon />
//             </IconButton>
//           )}
//         </Grid>
//       </Grid>
//     ))}
//   </>
// )}
//       </Paper>
//     </SpacingContainer>
//   )
// }

// export default connect(FederalAgencyResources)
